import { FC, MouseEvent, RefObject, useCallback } from 'react';
import clsx from 'clsx';
import { Icon } from '@namespace/icons2';
import { AText } from '../../../AText';
import { Box } from '../../../Box';
import { PhoneCode } from '../../types';

import styles from './index.module.css';

interface CodesListProps {
  setShow: (show: boolean) => void;
  handleChangeCode: (phoneCode: string, iso1Code: string) => void;
  codes: PhoneCode[];
  filterRef?: RefObject<HTMLDivElement>;
  value: { code: string; isoCode: string } | null;
  size?: 's' | 'm';
}

export const CodesList: FC<CodesListProps> = ({
  setShow,
  handleChangeCode,
  codes,
  filterRef,
  value,
  size = 's'
}) => {
  const handleClickFactory = useCallback(
    (phoneCode: string, iso1Code: string) =>
      (e: MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        handleChangeCode(phoneCode, iso1Code);
        setShow(false);
      },
    [handleChangeCode, setShow]
  );

  return (
    <Box
      className={`${styles.general} ${styles[size]}`}
      ref={filterRef}
      direction="column"
    >
      {codes.map(({ countryName, phoneCode, iso1Code }) => {
        const isActive =
          value && phoneCode === value.code && iso1Code === value.isoCode;
        return (
          <Box
            key={countryName}
            align="center"
            onClick={handleClickFactory(phoneCode, iso1Code)}
            className={clsx(styles.option, isActive && styles.active)}
          >
            <AText className={styles.title} color="txt_color_3">
              {`+${phoneCode} ${countryName}`}
            </AText>
            {isActive && (
              <Icon
                name="icons/general/action/done"
                color="state_success"
                size="m"
              />
            )}
          </Box>
        );
      })}
    </Box>
  );
};
